window.AAAdminWorkspaceView = (() => {
  const PARAM = 'aa_admin_client';

  let authorizedClientId = null;
  let authorizedClientName = null;
  let authorizedUser = null;
  let authorizedRole = null;

  function getRequestedClientId() {
    const params = new URLSearchParams(window.location.search);

    return params.get(PARAM)?.trim() || null;
  }

  async function getAuthorizedClientId() {
    const requestedClientId = getRequestedClientId();
    authorizedClientId = null;
    authorizedClientName = null;
    authorizedUser = null;
    authorizedRole = null;

    // No client selected must never default to another store.
    if (!requestedClientId) return null;

    if (
      !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(requestedClientId) ||
      !window.AAWorkspaceContext?.getWorkspaceAuthContext
    ) {
      return null;
    }

    const auth =
      await window.AAWorkspaceContext.getWorkspaceAuthContext();

    if (!auth?.user || auth?.locked || auth.isInternal !== true) {
      return null;
    }

    const db = window.AASupabaseClient?.getClient?.();
    if (!db) return null;

    // Validate the requested client against the database.
    const { data: client, error } = await db
      .from('aa_clients')
      .select('id, business_name')
      .eq('id', requestedClientId)
      .maybeSingle();

    if (error || !client) return null;

    authorizedClientId = client.id;
    authorizedClientName = String(client.business_name || '').trim() || null;
    authorizedUser = auth.user;
    authorizedRole = auth.role;
    return authorizedClientId;
  }

  function preserveAdminClientInLinks() {
    if (!authorizedClientId) return;

    document
      .querySelectorAll('.aa-workspace a[href^="/pages/workspace-"]')
      .forEach((link) => {
        const url = new URL(link.href, window.location.origin);

        url.searchParams.set(PARAM, authorizedClientId);

        link.href =
          `${url.pathname}${url.search}${url.hash}`;
      });
  }

  function watchModuleNavigation() {
    const mount =
      document.querySelector('[data-aa-client-module-nav]');

    if (!mount || !authorizedClientId) return;

    const observer = new MutationObserver(() => {
      preserveAdminClientInLinks();
    });

    observer.observe(mount, {
      childList: true,
      subtree: true
    });
  }

  function showBackToHeadquarters() {
    // Authorized client selection already verified the internal user's
    // session and client access. Avoid another asynchronous auth round trip.
    if (!authorizedClientId || !authorizedUser) return;

    const actions = document.querySelector('.aa-workspace__header-actions');
    if (!actions) return;

    const button = actions.querySelector('[data-aa-back-to-headquarters]');
    if (button) button.hidden = false;
  }

  function enhanceWorkspace() {
    if (authorizedClientId) {
      preserveAdminClientInLinks();
      watchModuleNavigation();
    }

    showBackToHeadquarters();
  }

  function getClientId() {
    return authorizedClientId;
  }

  function getClientName() {
    return authorizedClientName;
  }

  function getVerifiedAccountIdentity() {
    if (!authorizedClientId || !authorizedUser) return null;
    return {
      user: authorizedUser,
      role: authorizedRole,
      isInternal: true
    };
  }

  return {
    getAuthorizedClientId,
    enhanceWorkspace,
    getClientId,
    getClientName,
    getVerifiedAccountIdentity
  };
})();